
import { RightOutlined } from "@ant-design/icons";
import {

    Row,
    Col,

    Button,

    Form,
    Input,

    Select,

    Radio,

    Space,
    TimePicker,
    DatePicker


} from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';

import ProgrammeService from "../../../api/programme.service";
import timeSlotService from "../../../api/time.slot.service";

import moment from 'moment';


import { DATE_FORMAT_DMY_SLASH, EDIT_MODE, SUCCESS_STATUS, TIME_FORMAT } from "../../../utility/Constants";

import CustomMessage from "../../common/CustomMessage";

import commonUtility from "../../../utility/Utils";
import holidayService from "../../../api/holiday.service";
import { addHoliday } from "../../../store/holidaySlice";
import TextArea from "antd/lib/input/TextArea";
const { Option } = Select;



const HolidayEntry = ({ data, onDrawerClose }) => {

    const dispatch = useDispatch();

    // console.log(data)
    const [isFormResponse, setIsFormResponse] = useState(false);
    const [formResponseMessage, setFormResponseMessage] = useState("");
    const [formResponseStatus, setFormResponseStatus] = useState("");

    const [formDefaultValues, setFormDefaultValues] = useState({
        holiday_id: data.holiday_id,
        type:data.type,
        holiday_date: data.holiday_date,
        holiday_description: data.holiday_description,
        tap_group: data.tap_group,
        mode: data.mode
    });

    const [mode, setMode] = useState(data.mode);


    const [form] = Form.useForm();



    const onDateChange = (date, dateString) => {
        form.setFieldsValue({
            holiday_date: dateString,
        });
    };

    const onHolidaySave = async (values) => {
        console.log("Holiday", values);
        const data = { formdata: values };

        const response = holidayService.save(data).then((resdata) => {

            setIsFormResponse(true);
            setFormResponseStatus(resdata.response_status);
            setFormResponseMessage(resdata.response_msg);

            const x = {
                holiday_id: commonUtility.randomID(),
                type:values.type,
                holiday_date: values.holiday_date,
                holiday_description: values.holiday_date,
            }

            dispatch(addHoliday(x))


        });


    };



    const hideResponseMessage = () => {
        setIsFormResponse(false);
        if (mode == "ADD") {
            form.resetFields();
            form.setFieldsValue({
                holiday_id: formDefaultValues.holiday_id,
                type:formDefaultValues.type,
                holiday_date: formDefaultValues.holiday_date,
                holiday_description: formDefaultValues.holiday_description,
                tap_group: formDefaultValues.tap_group,
                mode: formDefaultValues.mode,
            })
        }

    }








    useEffect(() => {

        mode == EDIT_MODE ?
            form.setFieldsValue({
                holiday_id: formDefaultValues.holiday_id,
                type:formDefaultValues.type,
                holiday_date: formDefaultValues.holiday_date,
                holiday_date_picker: formDefaultValues.holiday_date != null && formDefaultValues.holiday_date != "" ? moment(formDefaultValues.holiday_date, DATE_FORMAT_DMY_SLASH) : '',
                holiday_description: formDefaultValues.holiday_description,
                tap_group: formDefaultValues.tap_group,
                mode: formDefaultValues.mode
            })
            :
            form.setFieldsValue({
                holiday_id: 0,
                type:'',
                holiday_date: '',
                holiday_description: '',
                tap_group: '',
                mode: data.mode,
            });


        form.setFieldsValue(formDefaultValues)

    }, [form]);







    return (
        <div>
            <div className="form-input-style">

                <Row className="" style={{ background: "transparent" }}>
                    <Col className="" xs={24} xl={24}>
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={onHolidaySave}
                            autoComplete="off"
                        // initialValues={formDefaultValues}
                        >

                            {/* <Row gutter={20}>
                            <Col className="gutter-row" xs={24} xl={24}>
                                <h5>Note: * fields are required</h5>
                            </Col>
                        </Row> */}
                            <Row gutter={20}>
                                <Col className="gutter-row" xs={24} xl={6}>
                                    <Form.Item name="type" label="Type" rules={[
                                        {
                                            required: true,
                                            message: 'Type is required',
                                        },
                                    ]}>
                                        <Select className="text-left" >
                                            <Option value="">Select</Option>
                                            <Option value="H">Holiday</Option>
                                            <Option value="O">Other</Option>
                                        </Select>
                                    </Form.Item>

                                    <Form.Item name="holiday_id" label="holiday_id" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                    <Form.Item name="mode" label="mode" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                </Col>



                               

                                <Col xs={24} sm={6}>
                                    <Form.Item name="holiday_date_picker" label="Date" rules={[
                                        {
                                            required: true,
                                            message: 'Date is required',
                                        },
                                    ]}>
                                        <DatePicker
                                            format="DD/MM/YYYY"
                                            onChange={onDateChange}
                                            style={{ width: "100%" }}
                                            inputReadOnly={true}
                                        />
                                    </Form.Item>
                                    <Form.Item name="holiday_date" label="holiday_date" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={12}>
                                    <Form.Item name="tap_group" label="Adult Coaching / Special Coaching">
                                        <Select className="text-left" defaultValue="Select">
                                            <Option value="">Select</Option>
                                            <Option value="TAPM" valueText="Adult Coaching"> Adult Coaching</Option>
                                            <Option value="TAPSC" valueText="Special Coaching"> Special Coaching</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>



                                <Col xs={24} xl={24}>
                                    <Form.Item name="holiday_description" label="Description" >
                                        <TextArea rows={2} placeholder="" />
                                    </Form.Item>
                                </Col>




                                <Col xs={24} xl={12}>
                                    <Form.Item name="" label=" ">
                                        <Space>

                                            <Button htmlType="submit" className="custom-button-green" >
                                                Save <RightOutlined />
                                            </Button>
                                        </Space>
                                    </Form.Item>
                                </Col>


                            </Row>
                        </Form>



                    </Col>
                </Row>
                {
                    // isFormResponse ? <CustomMessage title={formResponseStatus} subtitle={formResponseMessage} action={hideResponseMessage} /> : ''
                    isFormResponse ? <CustomMessage title={formResponseStatus} subtitle={formResponseMessage} action={hideResponseMessage} onDrawerClose={onDrawerClose} mode={form.getFieldValue('mode')} /> : ''
                }




            </div>
        </div>
    );
};

export default HolidayEntry;
